import { useNavigate } from 'react-router-dom';
import AnalyticsCriteriaCard from '../AnalyticsCriteriaCard/AnalyticsCriteriaCard';
import './AnalyticsCriteriaHeader.css';
import getNameFromEmail from '/src/utils/getNameFromEmail';
import { buildCriteriaKey } from '/src/utils/criteriaKey';

const CONVERSATIONS_LIST_PATH = '/supervision/conversations/list';

const AnalyticsCriteriaHeader = ({ item, byAgent = [], criteriaResults = [] }) => {
  const navigate = useNavigate();

  const buildConversationsUrl = (extraFilters) => {
    const filters = {
      criteria_ids: item?.id != null ? [buildCriteriaKey(item.category, item.id)] : [],
      ...extraFilters
    };

    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      (Array.isArray(value) ? value : [value]).forEach((v) => {
        if (v !== undefined && v !== null && v !== "") params.append(key, v);
      });
    });

    return `${CONVERSATIONS_LIST_PATH}?${params.toString()}`;
  };

  const goToConversations = (extraFilters) => {
    navigate(buildConversationsUrl(extraFilters));
  };

  const topPerformer = byAgent.length
    ? [...byAgent].sort((a, b) => b.passRateValue - a.passRateValue || b.interactions - a.interactions)[0]
    : null;
  const bottomPerformerCandidate = byAgent.length
    ? [...byAgent].sort((a, b) => a.passRateValue - b.passRateValue || b.interactions - a.interactions)[0]
    : null;
  const bottomPerformer = bottomPerformerCandidate && topPerformer && bottomPerformerCandidate.passRateValue < topPerformer.passRateValue
    ? bottomPerformerCandidate
    : null;

  return (
    <div className="analytics-criteria-header">
      <h2 className="analytics-criteria-main-title">{item?.name || "Criteria"}</h2>

      <div className="analytics-criteria-cards">
        <AnalyticsCriteriaCard
          title="Pass Rate"
          value={`${item?.passRate ?? 0}%`}
          subtitle="Avg."
        />

        <AnalyticsCriteriaCard
          title="Failed Interactions"
          value={`${item?.failed ?? 0}/${item?.total ?? 0}`}
          onClick={item?.failed ? () => goToConversations({ criteria_results: ['fail'] }) : undefined}
        />

        <AnalyticsCriteriaCard
          title="Top Performer"
          value={
            topPerformer ? (
              <div className="analytics-criteria-user">
                <div className="firstname">{getNameFromEmail(topPerformer.agent).firstName}</div>
                <div className="lastname">{getNameFromEmail(topPerformer.agent).lastName}</div>
              </div>
            ) : "N/A"
          }
          subtitle={topPerformer ? `${topPerformer.passRateValue}% Avg. Pass Rate` : ""}
          fontSize="16"
          copiedValue={topPerformer ? topPerformer.agent : undefined}
          onGoToConversations={topPerformer ? () => goToConversations({ agent_id: topPerformer.agent, criteria_results: criteriaResults }) : undefined}
          goToConversationsHref={topPerformer ? buildConversationsUrl({ agent_id: topPerformer.agent, criteria_results: criteriaResults }) : undefined}
        />

        <AnalyticsCriteriaCard
          title="Bottom Performer"
          value={
            bottomPerformer ? (
              <div className="analytics-criteria-user">
                <div className="firstname">{getNameFromEmail(bottomPerformer.agent).firstName}</div>
                <div className="lastname">{getNameFromEmail(bottomPerformer.agent).lastName}</div>
              </div>
            ) : "N/A"
          }
          subtitle={bottomPerformer ? `${bottomPerformer.passRateValue}% Avg. Pass Rate` : ""}
          fontSize="16"
          copiedValue={bottomPerformer ? bottomPerformer.agent : undefined}
          onGoToConversations={bottomPerformer ? () => goToConversations({ agent_id: bottomPerformer.agent, criteria_results: criteriaResults }) : undefined}
          goToConversationsHref={bottomPerformer ? buildConversationsUrl({ agent_id: bottomPerformer.agent, criteria_results: criteriaResults }) : undefined}
        />
      </div>
    </div>
  );
};

export default AnalyticsCriteriaHeader;